export default {
  style: {
    backgroundColor: 'transparent',
    height: '100%',
  },
  underlineStyle: {
    display: 'none',
  },
  labelStyle: {
    lineHeight: '37px',
    height: '37px',
    paddingLeft: '10px',
    fontSize: '15px',
    color: '#5e647f',
    top: 0,
  },
  iconStyle: {
    height: '35px',
    top: 0,
    right: '0',
    padding: '0 4px',
  },
  selectedMenuItemStyle: {
    color: '#4786ff',
  },
  hintStyle: {
    bottom: '5px',
    left: '10px',
  },
  errorStyle: {
    fontSize: '15px',
    fontStyle: 'italic',
    top: '10px',
    bottom: 0,
  },
};



// WEBPACK FOOTER //
// ../ui-components/components/Dropdown/style.js